export enum INPUT_TYPE {
  BUTTON = 'button',
  CHECKBOX = 'checkbox',
  EMAIL = 'email',
  NUMBER = 'number',
  PASSWORD = 'password',
  RADIO = 'radio',
  SELECT = 'select',
  SUBMIT = 'submit',
  TEL = 'tel',
  TEXT = 'text',
}
